import { useEffect, useRef } from 'react';
import { Bold, Italic, Underline, List, ListOrdered, Eraser } from 'lucide-react';

const TOOLS = [
  { cmd: 'bold', icon: Bold, label: 'Fett' },
  { cmd: 'italic', icon: Italic, label: 'Kursiv' },
  { cmd: 'underline', icon: Underline, label: 'Unterstrichen' },
  { cmd: 'insertUnorderedList', icon: List, label: 'Aufzählung' },
  { cmd: 'insertOrderedList', icon: ListOrdered, label: 'Nummerierung' },
  { cmd: 'removeFormat', icon: Eraser, label: 'Formatierung entfernen' },
];

export const RichTextEditor = ({ value, onChange, placeholder }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || '')) ref.current.innerHTML = value || '';
  }, [value]);

  useEffect(() => {
    document.execCommand('defaultParagraphSeparator', false, 'p');
  }, []);

  const exec = (cmd) => {
    ref.current?.focus();
    document.execCommand(cmd, false);
    onChange(ref.current.innerHTML);
  };

  return (
    <div data-testid="letter-rich-editor">
      <div className="sticky top-0 z-10 flex flex-wrap gap-1 mb-3 p-1 rounded-md bg-gray-100/90 backdrop-blur w-fit">
        {TOOLS.map(({ cmd, icon: Icon, label }) => (
          <button
            key={cmd}
            type="button"
            title={label}
            onMouseDown={(e) => { e.preventDefault(); exec(cmd); }}
            className="p-1.5 rounded text-gray-600 hover:bg-white hover:text-[#9B1B30] transition-colors"
            data-testid={`editor-tool-${cmd}`}
          >
            <Icon className="w-4 h-4" />
          </button>
        ))}
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        onFocus={(e) => { if (!e.currentTarget.innerHTML.trim()) document.execCommand('formatBlock', false, 'p'); }}
        data-placeholder={placeholder}
        className="letter-editor min-h-[320px] outline-none text-[15px] leading-relaxed text-gray-900 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-3 empty:before:content-[attr(data-placeholder)] empty:before:text-gray-400"
        data-testid="letter-body-editor"
      />
    </div>
  );
};

export default RichTextEditor;
